var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,on:{"click":_vm.selectOption}},[(_vm.selectedIsArray)?[(_vm.isSelected)?_c('i',{staticClass:"multi__icon sb-icon-check_box",attrs:{"aria-hidden":"true"}}):_c('i',{staticClass:"multi__icon sb-icon-check_box_outline_blank",attrs:{"aria-hidden":"true"}})]:_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }